module.exports = __webpack_public_path__ + "img/pcb_07@2x.c98354a7.png";